import styled from 'styled-components';

export const ButtonImage = styled.img`
  width: 15px;
  height: 15px;
  border-radius: 2px;
`;
